import SetCSSProperties from "./SetCSSProperties";
import ControlSubmenus from "./ControlSubmenus";
import CloseOnBackdropClick from "./CloseOnBackdropClick";

export default {
  SetCSSProperties,
  ControlSubmenus,
  CloseOnBackdropClick,
};
